import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslationInfo } from '@core-models/utilities/translation-info';
import { WrapWordsDirective } from '../../../core-modules/directives/wrap-words/wrap-words.directive';
import { RpcIconComponent } from '../../../core-modules/utils/rpc-icon/rpc-icon.component';
import { RpcButtonComponent } from '../../../core-modules/controls/components/rpc-button/rpc-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [WrapWordsDirective, RpcIconComponent, RpcButtonComponent, TranslateModule]
})
export class ToastComponent {

    @Input() translationInfo: TranslationInfo;

    @Output() public closed = new EventEmitter<void>();
    @Output() public navigateToNotification = new EventEmitter<void>();

    public onClose(): void {
        this.closed.emit();
    }

    public onReviewClick(): void {
        this.navigateToNotification.emit();
        this.onClose();
    }
}
